if(!customElements.get('yr-mascot-craft-anchor')){
  // A single delegated listener also survives theme editor section reloads.
  customElements.define('yr-mascot-craft-anchor',class extends HTMLElement{});
  document.addEventListener('click',event=>{
    const link=event.target.closest('.yr-mascot-craft-cta');
    if(!link||window.Shopify?.designMode||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||event.button!==0)return;
    const hash=link.getAttribute('href');if(!hash?.startsWith('#'))return;
    const target=document.getElementById(hash.slice(1));if(!target)return;
    event.preventDefault();
    const header=document.querySelector('#header-group')||document.querySelector('header-component');
    const inset=header?.getBoundingClientRect().height||0;
    const top=window.scrollY+target.getBoundingClientRect().top-inset-20;
    window.scrollTo({top:Math.max(0,top),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    target.setAttribute('tabindex','-1');target.focus({preventScroll:true});
  });
}
